import CheckMustResetPassword from './CheckMustResetPassword';

export default CheckMustResetPassword;
